import { motion } from "framer-motion";
import { Sofa, BedDouble, Layers, Home, LayoutGrid, Sparkles, ShieldCheck, HeartHandshake, BadgeCheck } from "lucide-react";
import { SERVICE_HIGHLIGHTS, TRUST_POINTS } from "../data/content";

const ICONS = {
  sofa: Sofa,
  bed: BedDouble,
  carpet: Layers,
  roof: Home,
  terrace: LayoutGrid,
  sparkles: Sparkles,
  shield: ShieldCheck,
  heart: HeartHandshake,
};

export const Services = () => {
  return (
    <section id="servicos" data-testid="services-section" className="py-20 sm:py-24 bg-[#0A1128]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.6 }}
          className="text-center max-w-2xl mx-auto"
        >
          <span className="text-xs font-bold tracking-[0.3em] uppercase text-sky-400">
            O que fazemos
          </span>
          <h2 className="mt-3 font-display text-2xl sm:text-3xl lg:text-4xl font-bold tracking-tight text-white">
            Especialistas em renovar o seu espaço
          </h2>
          <p className="mt-4 text-base text-slate-400 leading-relaxed">
            Da higienização de estofados à lavagem de exteriores, tratamos de
            tudo com equipamento profissional e ao domicílio.
          </p>
        </motion.div>

        <div className="mt-14 grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 sm:gap-6">
          {SERVICE_HIGHLIGHTS.map((s, i) => {
            const Icon = ICONS[s.icon];
            return (
              <motion.div
                key={s.label}
                data-testid={`service-highlight-${s.icon}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.08 }}
                className="card-glow flex flex-col items-center gap-3 rounded-2xl border border-white/10 bg-[#101D42] px-4 py-8 text-center"
              >
                <span className="flex h-14 w-14 items-center justify-center rounded-full bg-sky-400/15 text-sky-300 ring-1 ring-sky-400/30">
                  <Icon className="h-7 w-7" />
                </span>
                <span className="font-display text-sm font-bold tracking-wide text-white uppercase">
                  {s.label}
                </span>
              </motion.div>
            );
          })}
        </div>

        <div className="mt-16 grid sm:grid-cols-3 gap-6">
          {TRUST_POINTS.map((t, i) => {
            const Icon = ICONS[t.icon];
            return (
              <motion.div
                key={t.title}
                data-testid={`trust-point-${t.icon}`}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex gap-4 rounded-2xl border border-white/5 bg-white/[0.03] p-6"
              >
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-gradient-to-br from-sky-500 to-cyan-400 text-[#0A1128]">
                  <Icon className="h-5 w-5" />
                </span>
                <div>
                  <h3 className="font-display text-base font-bold text-white flex items-center gap-1.5">
                    {t.title}
                    <BadgeCheck className="h-4 w-4 text-sky-400" />
                  </h3>
                  <p className="mt-1 text-sm text-slate-400 leading-relaxed">{t.text}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};
